import { defineComponent as _defineComponent } from 'vue'
import { createVNode as _createVNode, unref as _unref, createElementVNode as _createElementVNode, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, toDisplayString as _toDisplayString, createElementBlock as _createElementBlock, createTextVNode as _createTextVNode, resolveDirective as _resolveDirective, withDirectives as _withDirectives } from "vue"

const _hoisted_1 = {
  key: 0,
  class: "container-fluid",
  style: {"margin-top":"80px","padding-top":"40px"}
}
const _hoisted_2 = { class: "row" }
const _hoisted_3 = { class: "col-lg-6 text-right align-self-end" }
const _hoisted_4 = {
  class: "alert alert-info",
  role: "alert"
}
const _hoisted_5 = { key: 0 }
const _hoisted_6 = { key: 1 }
const _hoisted_7 = { class: "toolbar" }
const _hoisted_8 = {
  class: "btn-group",
  role: "group"
}
const _hoisted_9 = { class: "btn btn-outline-secondary" }

import { computed, onMounted, watch, ref, type Ref } from 'vue'
    import { useRoute, onBeforeRouteLeave } from 'vue-router'

    import { SavingState } from '@common/Common'
    import CorporateNavigation from '@common/Components/CorporateNavigation.vue'
    import EditableValueSeriesSheet from '@common/Components/EditableValueSeriesSheet.vue'
    import SaveButton from '@common/Components/SaveButton.vue'
    import ValueSeriesTable from '@Quest/_Common/Components/ValueSeriesTable.vue'

    import { useResourceUnitCostsQueryV1 } from '@Quest/Resources/queries-vue-composables'
    import { useUpdateResourceUnitCostsCommandV1 } from '@Quest/Strategies/commands-vue-composables'

    import type { ResourceUnitCostsReadModel } from '@Quest/Resources/readmodels'

    
export default /*@__PURE__*/_defineComponent({
  __name: 'ResourceUnitCostsPage',
  setup(__props) {

    const route = useRoute()

    const workspaceId = computed(() => Number(route.params.workspaceId ?? 0))
    const strategyId = computed(() => String(route.params.strategyId ?? ''))

    // --------------------
    // Query
    // --------------------

    const {
        runResourceUnitCostsQueryV1,
        modelResourceUnitCostsQueryV1
    } = useResourceUnitCostsQueryV1(workspaceId, strategyId)

    const rm = modelResourceUnitCostsQueryV1 as Ref<ResourceUnitCostsReadModel | null>

    // --------------------
    // Command
    // --------------------

    const {
        invokeUpdateResourceUnitCostsCommandV1,
        succeedUpdateResourceUnitCostsCommandV1
    } = useUpdateResourceUnitCostsCommandV1(workspaceId, strategyId)

    // --------------------
    // State
    // --------------------

    const isEditing = ref(false)
    const savingState = ref<SavingState>(SavingState.Saved)

    // --------------------
    // Computed
    // --------------------

    const title = computed(() =>
        `${rm.value?.Title} (${rm.value?.CurrencyLabel})`
    )

    const stopEditingLabel = computed(() =>
        savingState.value === SavingState.Pending
            ? "Cancel editing"
            : "Back"
    )

    const inputSeries = computed(() =>
        rm.value?.Series.filter(a => !a.IsTotal) ?? []
    )

    // --------------------
    // Methods
    // --------------------

    function startEditing()
    {
        isEditing.value = true
    }

    function cancelEditing()
    {
        if (savingState.value === SavingState.Saved)
        {
            isEditing.value = false
        }
        else if (
            savingState.value === SavingState.Pending &&
            confirm("You have unsaved changes. Are you sure you want to cancel editing?")
        )
        {
            savingState.value = SavingState.Saved
            isEditing.value = false
        }
    }

    function onDataChange()
    {
        savingState.value = SavingState.Pending
    }

    const sheet = ref<any>(null)

    function handleSaveCommand()
    {
        const entries = sheet.value?.getEntriesForSave()

        invokeUpdateResourceUnitCostsCommandV1({
            fromYear: rm.value!.FromYear,
            entries
        })

        savingState.value = SavingState.InProgress
    }

    // --------------------
    // Lifecycle
    // --------------------

    onMounted(() =>
    {
        document.title = "Resource unit costs | TransparentChoice"
        runResourceUnitCostsQueryV1()
    })

    // --------------------
    // Command Success Watcher
    // --------------------

    watch(succeedUpdateResourceUnitCostsCommandV1, (current, previous) =>
    {
        if (current && !previous)
        {
            runResourceUnitCostsQueryV1()

            if (savingState.value === SavingState.InProgress)
            {
                savingState.value = SavingState.Saved
            }
        }
    })

    // --------------------
    // Route Leave Guard
    // --------------------

    onBeforeRouteLeave((to, from, next) =>
    {
        if (savingState.value === SavingState.Pending)
        {
            if (confirm("You have unsaved changes. Do you want to save them before leaving?"))
            {
                handleSaveCommand()
                next()
            } else
            {
                next()
            }
        } else
        {
            next()
        }
    })

return (_ctx: any,_cache: any) => {
  const _directive_sanitizedHref = _resolveDirective("sanitizedHref")!

  return (_openBlock(), _createElementBlock("div", null, [
    _createVNode(CorporateNavigation, { ActivePage: "resources" }),
    (_unref(rm))
      ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
          _createElementVNode("div", _hoisted_2, [
            _cache[1] || (_cache[1] = _createElementVNode("div", { class: "col-lg-6" }, [
              _createElementVNode("h1", { style: {"font-size":"2em","font-weight":"300","color":"#33475b","margin":"0"} }, "Unit costs")
            ], -1 /* CACHED */)),
            _createElementVNode("div", _hoisted_3, [
              (isEditing.value)
                ? (_openBlock(), _createBlock(SaveButton, {
                    key: 0,
                    class: "mr-1",
                    savingState: savingState.value,
                    onSaveChanges: _cache[0] || (_cache[0] = ($event: any) => (handleSaveCommand()))
                  }, null, 8 /* PROPS */, ["savingState"]))
                : _createCommentVNode("v-if", true),
              (isEditing.value)
                ? (_openBlock(), _createElementBlock("button", {
                    key: 1,
                    class: "btn btn-outline-secondary",
                    style: {"padding":"0.7em 2em"},
                    onClick: cancelEditing
                  }, _toDisplayString(stopEditingLabel.value), 1 /* TEXT */))
                : _createCommentVNode("v-if", true),
              (!isEditing.value)
                ? (_openBlock(), _createElementBlock("button", {
                    key: 2,
                    class: "btn btn-success",
                    style: {"padding":"0.7em 2em"},
                    onClick: startEditing
                  }, "Edit unit costs"))
                : _createCommentVNode("v-if", true)
            ])
          ]),
          _cache[6] || (_cache[6] = _createElementVNode("hr", { style: {"border-color":"#bbb","margin":"20px 0 60px"} }, null, -1 /* CACHED */)),
          _createElementVNode("div", _hoisted_4, _toDisplayString(_unref(rm)?.FiscalYearRangeLabel), 1 /* TEXT */),
          (isEditing.value)
            ? (_openBlock(), _createElementBlock("div", _hoisted_5, [
                _cache[2] || (_cache[2] = _createElementVNode("div", {
                  class: "alert alert-warning",
                  role: "alert"
                }, " Warning: Formula entered here will save as values. ", -1 /* CACHED */)),
                _createVNode(EditableValueSeriesSheet, {
                  ref_key: "sheet",
                  ref: sheet,
                  propTitle: title.value,
                  propSeries: inputSeries.value,
                  propColumns: _unref(rm).Columns,
                  onDataChange: onDataChange
                }, null, 8 /* PROPS */, ["propTitle", "propSeries", "propColumns"])
              ]))
            : (_openBlock(), _createElementBlock("div", _hoisted_6, [
                _createElementVNode("div", _hoisted_7, [
                  _createElementVNode("div", null, [
                    _createElementVNode("div", _hoisted_8, [
                      _withDirectives((_openBlock(), _createElementBlock("a", _hoisted_9, [...(_cache[3] || (_cache[3] = [
                        _createTextVNode(" Resources ", -1 /* CACHED */)
                      ]))])), [
                        [_directive_sanitizedHref, `/#/enterprise/resources/${workspaceId.value}/${strategyId.value}`]
                      ]),
                      _cache[4] || (_cache[4] = _createElementVNode("span", { class: "btn btn-secondary disabled" }, " Unit costs ", -1 /* CACHED */))
                    ])
                  ]),
                  _cache[5] || (_cache[5] = _createElementVNode("div", null, null, -1 /* CACHED */))
                ]),
                _createVNode(ValueSeriesTable, {
                  propTitle: title.value,
                  propSeries: _unref(rm).Series,
                  propColumns: _unref(rm).Columns
                }, null, 8 /* PROPS */, ["propTitle", "propSeries", "propColumns"])
              ]))
        ]))
      : _createCommentVNode("v-if", true)
  ]))
}
}

})